import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Link02 = function Link02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 17H7c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h2m6 10h2c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5h-2m-8 5h10"
    })
  }));
};
export default Link02;